module.exports = __webpack_public_path__ + "img/animal_task.1a0c3807.png";